import { Button, Modal } from 'react-bootstrap';

interface ReviewAvailabilityProps {
  show: boolean;
  onHide: (result: boolean) => void;
}

export const ReviewAvailability = ({ show, onHide }: ReviewAvailabilityProps) => {
  return (
    <Modal show={show}>
      <Modal.Header>
        <Modal.Title>Check Your Schedule</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Please update your availability to allow connections to send assignment requests once you
        are approved.
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-primary" onClick={() => onHide(false)}>
          Review Later
        </Button>
        <Button variant="primary" onClick={() => onHide(true)}>
          Open Calendar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
